<template lang="html">
  <article class="media">
    <div class="media-content">
      <div class="content">
        <p>
          <strong>Software Automation Engineer</strong> | Aperi - <small>Mar 2014 - Jan 2017</small>
          <br>
At Aperi I played the role of full time developer and sales engineer. I helped
wrap FPGA cores in RESTful API's so that they could be easily reconfigured on
the fly. Having built the CI/CD pipeline for our Docker infrastructure, I ran
operations for deployment of new applications behind firewalled environments
across the globe. My favorite creation at the company used meta-programming to
build an ORM for FPGA register maps. The approach sped up our development while
reducing interface error by a significant margin.
        </p>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: "aperi"
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/jobs/Aperi.vue